import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Layout({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleNavClick = (sectionId) => {
    if (isHome) {
      scrollToSection(sectionId);
    } else {
      setIsMenuOpen(false);
    }
  };

  const NavLink = ({ to, sectionId, children }) => {
    if (isHome) {
      return (
        <button onClick={() => handleNavClick(sectionId)}>
          {children}
        </button>
      );
    }
    return (
      <Link to={to} onClick={() => setIsMenuOpen(false)}>
        {children}
      </Link>
    );
  };

  return (
    <div className="App">
      <div className="floating-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
        <div className="orb orb-4"></div>
        <div className="orb orb-5"></div>
      </div>

      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="logo-container">
            <Link to="/" className="logo-link">
              <div className="hamsa-symbol">🪬</div>
              <h1 className="logo">Hamsa's Tarot</h1>
            </Link>
          </div>
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <NavLink to="/" sectionId="home">Home</NavLink>
            <NavLink to="/#about" sectionId="about">About</NavLink>
            <NavLink to="/#services" sectionId="services">Services</NavLink>
            <NavLink to="/#pricing" sectionId="pricing">Pricing</NavLink>
            <NavLink to="/#testimonials" sectionId="testimonials">Testimonials</NavLink>
            <NavLink to="/#contact" sectionId="contact">Contact</NavLink>
          </nav>
          <div className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {children}

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <Link to="/" className="footer-logo">
              <div className="hamsa-symbol">🪬</div>
              <span>Hamsa's Tarot</span>
            </Link>
            <p>&copy; 2024 Hamsa's Tarot. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
